var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransferCar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 8,
    fill: "#FF086B"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_709_25683)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.58334 19.5833C8.58334 20.0696 8.7765 20.5359 9.12031 20.8797C9.46413 21.2235 9.93045 21.4167 10.4167 21.4167C10.9029 21.4167 11.3692 21.2235 11.713 20.8797C12.0569 20.5359 12.25 20.0696 12.25 19.5833C12.25 19.0971 12.0569 18.6308 11.713 18.287C11.3692 17.9432 10.9029 17.75 10.4167 17.75C9.93045 17.75 9.46413 17.9432 9.12031 18.287C8.7765 18.6308 8.58334 19.0971 8.58334 19.5833Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.75 19.5833C17.75 20.0696 17.9432 20.5359 18.287 20.8797C18.6308 21.2235 19.0971 21.4167 19.5833 21.4167C20.0696 21.4167 20.5359 21.2235 20.8797 20.8797C21.2235 20.5359 21.4167 20.0696 21.4167 19.5833C21.4167 19.0971 21.2235 18.6308 20.8797 18.287C20.5359 17.9432 20.0696 17.75 19.5833 17.75C19.0971 17.75 18.6308 17.9432 18.287 18.287C17.9432 18.6308 17.75 19.0971 17.75 19.5833Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.58334 19.583H6.75001V15.9163M5.83334 8.58301H15.9167V19.583M12.25 19.583H17.75M21.4167 19.583H23.25V14.083M23.25 14.083H15.9167M23.25 14.083L20.5 9.49967H15.9167",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.75 12.25H10.4167",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_709_25683"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransferCar);
export default __webpack_public_path__ + "static/media/TransferCar.1271701d1be7894b629ac41782135fbe.svg";
export { ForwardRef as ReactComponent };